/**
 * V7 (VISTOERA_CANVAS_VIDEO_PLAYER_ARCHITECTURE_ROOT_CAUSE_AND_POSTER_FIRST_
 * ACTIVE_PLAYER_V7) — PRIME_LOGIC_REMOVED.
 *
 * V3–V6 seeked a *permanently-mounted, idle* <video> element through
 * candidate timestamps (0, 0.05, 0.1, 0.25s) purely to produce a decoded
 * "cover" frame to show while nothing was playing. Under the V7 poster-
 * first architecture, an idle completed node never mounts a <video>
 * element at all — the canonical poster asset IS the idle cover — so
 * there is nothing to prime while idle, and that whole seek machinery
 * (`primeVideoInitialFrame`, `bindInitialVideoFramePrime`,
 * `initialPreviewSeekCandidates`, `waitSeeked`) is deleted rather than
 * kept "just in case": every one of those seeks was itself a small network
 * fetch + decoder activation for a node nobody was looking at, which is
 * exactly the kind of permanent-resource-per-idle-node cost this
 * architecture pass removes.
 *
 * `isDrawableVideoFrame` survives because the ACTIVE player still needs it
 * — CanvasVideoPreview uses it once a `<video>` is actually mounted
 * (STARTING phase) to decide when to swap away from the poster onto the
 * freshly-decoding video, so playback never flashes an undecoded black
 * t=0 frame.
 */

const HAVE_CURRENT_DATA = 2

export function isDrawableVideoFrame(video: HTMLVideoElement): boolean {
  return video.readyState >= HAVE_CURRENT_DATA && video.videoWidth > 0 && video.videoHeight > 0
}
